import { Component, Input, OnInit } from '@angular/core';
import { ControlButton } from '../viewModels/layout.viewModel';

@Component({
    selector: 'opath-core-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    standalone: false
})
export class TopbarComponent implements OnInit {
  @Input() controlButtons: ControlButton[];
  @Input() rtlEnabled: boolean = true;

  constructor() {}

  async ngOnInit(): Promise<void> {}

  refreshTitles(): void {}
}
